(ns pfo.search.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [pfo.search.component :as component]
            [pfo.search.model :as model]
            [pfo.common.component :refer [empty-page]]
            [pfo.api :refer [process-error]]
            [pfo.util :as util]))

(defroute "/search" [query-params]
  (->> (model/search (:query query-params) nil)
       (p/map (fn [search-response]
                (util/set-page (#'component/search-results (:query query-params) search-response))))
       (process-error))
  (util/set-initial-page empty-page))

